import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { SurveyService } from 'src/app/services/survey.service';

@Component({
  selector: 'app-survey-header',
  templateUrl: './survey-header.component.html',
  styleUrls: ['./survey-header.component.scss'],
})
export class SurveyHeaderComponent implements OnInit {

  surveyForm: FormGroup;
  constructor(
    public dataServ: DataService,
    private formBuilder: FormBuilder,
    public authServ: AuthService,
    private surveyServ: SurveyService,
    private router: Router) { }

  async ngOnInit() {
    if (!this.authServ.isLogged) {
      this.router.navigateByUrl('/profile');
    }

    try {
      await this.authServ.getMe();
      this.surveyForm = this.formBuilder.group({
        name: [this.authServ.profile ? this.authServ.profile.first_name : '', [Validators.required]],
        surname: [this.authServ.profile ? this.authServ.profile.last_name : '', [Validators.required]],
        room_no: [this.authServ.profile ? this.authServ.profile.room_no : ''],
        email: [this.authServ.profile ? this.authServ.profile.e_mail : '', [Validators.required]],
        phone_no: [this.authServ.profile ? this.authServ.profile.phone_no : ''],
      });
    } catch (error) {

    }

  }
  async next() {
    this.surveyServ.surveyForm = this.surveyForm.value;

    let SURVEYS = await (await this.surveyServ.getSurveys()).filter(survey => survey.status === 'active');

    if (SURVEYS.length > 1) {
      this.router.navigateByUrl('/home/survey-list');
    }
    else {
      this.router.navigateByUrl('/home/survey-list/' + SURVEYS[0].id);
    }
  }
}
